import { Sport } from "@sportactics/board-editing";
import { Team } from "@sportactics/player-management";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useCustomPlayersFirestorePersistence(): useCustomPlayersFirestorePersistenceReturn {
  return useLazyContext(CustomPlayersFirestorePersistenceContext);
}

export type useCustomPlayersFirestorePersistenceReturn = {
  getTeamsWithSport: (userId: string, sport: Sport) => Promise<Team[]>;
  getTeamWithId: (userId: string, id: string) => Promise<Team>;
  createTeam: (userId: string, team: Team) => Promise<void>;
  updateTeam: (userId: string, id: string, team: Team) => Promise<void>;
  deleteTeam: (userId: string, id: string) => Promise<void>;
};

export const CustomPlayersFirestorePersistenceContext =
  createContext<LazyValue<useCustomPlayersFirestorePersistenceReturn>>(
    undefined,
  );
